import type { JSX } from 'react'
import type { IButtonProps } from 'atoms/Button'

import { ButtonFonts } from 'atoms/Button'
import { PlayerPaymentPrimaryButton } from 'atoms/Button/Templates'
import { TextBox } from 'atoms/TextBox'
import { Colors, TextAligning, TextBoxTypes } from 'atoms/TextBox/TextBox.h'
import { FIXED_INDENTS } from 'vars/index'
import {
  PlayerPayPopupButtonSC,
  PlayerPayPopupSC,
  PlayerPayPopupSmallSC,
  PlayerPayPopupTextSC,
} from './PlayerPayPopup.styled'

export interface IPlayerPayPopupProps extends Pick<IButtonProps, 'onClick'> {
  smallPlayer?: boolean
  title: string
  subtitle: string
  isFullscreen?: boolean
  buttonTitle: string
}

export const PlayerPayPopup = ({
  smallPlayer = false,
  title,
  subtitle,
  isFullscreen = false,
  buttonTitle,
  onClick,
}: IPlayerPayPopupProps): JSX.Element => {
  const isSmallPlayer = smallPlayer && !isFullscreen

  const config = isSmallPlayer
    ? {
        titleFont: TextBoxTypes.FontLg,
        subtitleFont: TextBoxTypes.FontXs,
        textGap: FIXED_INDENTS.INDENT_20,
        childrenGap: FIXED_INDENTS.INDENT_40,
      }
    : {
        titleFont: TextBoxTypes.FontXl,
        subtitleFont: TextBoxTypes.FontSm,
        textGap: FIXED_INDENTS.INDENT_30,
        childrenGap: FIXED_INDENTS.INDENT_60,
      }

  const { titleFont, subtitleFont, textGap, childrenGap } = config

  const WrapperSC = isSmallPlayer ? PlayerPayPopupSmallSC : PlayerPayPopupSC

  return (
    <WrapperSC gap={childrenGap}>
      <PlayerPayPopupTextSC gap={textGap}>
        <TextBox
          title={title}
          color={Colors.TEXT_ICON_PRIMARY}
          font={titleFont}
          maxLines={2}
          alignment={TextAligning.Center}
        />
        <TextBox
          title={subtitle}
          color={Colors.TEXT_ICON_SECONDARY}
          font={subtitleFont}
          maxLines={2}
          alignment={TextAligning.Center}
        />
      </PlayerPayPopupTextSC>

      <PlayerPayPopupButtonSC>
        <PlayerPaymentPrimaryButton
          font={ButtonFonts.FontSmBold}
          title={buttonTitle}
          onClick={onClick}
        />
      </PlayerPayPopupButtonSC>
    </WrapperSC>
  )
}
